import { Component, EventEmitter, Input, Output } from '@angular/core';

// Shared AI action button (icon + label, with a busy spinner state), so the Auto Tag and Smart
// Link triggers stay visually identical. Currently used by the Tagging panel; Smart Linking
// (related-data / content-status-card) can adopt it later. It stops event propagation itself so it
// can live inside a clickable expansion-panel header without toggling it.
@Component({
  selector: 'app-ai-action-button',
  templateUrl: './ai-action-button.component.html',
  styleUrls: ['./ai-action-button.component.scss'],
})
export class AiActionButtonComponent {
  @Input() label = '';
  @Input() busyLabel = '';
  @Input() busy = false;
  @Input() disabled = false;
  @Input() title = '';
  @Output() run = new EventEmitter<void>();

  onClick(event: Event): void {
    event.stopPropagation();
    this.run.emit();
  }
}
